module.exports = __webpack_public_path__ + "img/icon-cart.1a041b24.png";